import { render, staticRenderFns } from "./MultiImageUpload.vue?vue&type=template&id=13c2c9f9&scoped=true&"
import script from "./MultiImageUpload.vue?vue&type=script&lang=js&"
export * from "./MultiImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./MultiImageUpload.vue?vue&type=style&index=0&id=13c2c9f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c2c9f9",
  null
  
)

export default component.exports